<template>
  <div class="flex-folders">
    <div class="flex-table">
      <div v-if="loading" class="text-center text-success my-2">
          <b-spinner class="align-middle mr-2" />
          <strong>Loading...</strong>
      </div>
      <div>
        <b-form inline @submit.prevent="nullfunction">
          <sl-vue-tree
            ref="folderTree"
            v-model="nodes"
            class="w-100"
            :allow-multiselect="allowmultiselect"
            @nodeclick="toggleExpand" @drop="nodeDropped" @beforedrop="checkDrop"
          >
            <template slot="toggle" slot-scope="{ node }">
              <span v-if="node.data.gdqtype == 3 || node.data.gdqtype == 0">
                <i v-if="!node.isExpanded && node.children.length > 0" class="fa fa-regular fa-angle-down mr-2" />
                <i v-if="node.isExpanded && node.children.length > 0" class="fa fa-regular fa-angle-up mr-2" />
              </span>
              <!-- span v-if="node.data.gdqtype == 1">
                <span v-if="node.data.group_deleted == 0" class="sl-vue-tree-toggle">A</span>
              </span -->
            </template>
            <template slot="title" slot-scope="{ node }">
              <span class="item-icon">
                <i v-if="node.data.gdqtype == 0 && node.data.folder_id == 0" name="folder"
                  class="fa fa-regular fa-user" />
                <i v-if="node.data.gdqtype == 0 && node.data.folder_id != 0" name="folder"
                  class="fa fa-regular fa-folder" />
                <i v-if="node.data.gdqtype == 1" name="folder" class="fa fa-regular fa-users group-clickable"
                  @click.prevent="group_setcurrent(node.data.group_id)" />
                <fa-icon v-if="node.data.gdqtype == 3" name="trash-alt" />
                <fa-icon v-if="node.data.gdqtype == 4" name="folder" class="text-primary" />
              </span>
              <!-- Type 0 = Folder -->
              <span v-if="node.data.gdqtype == 0" class="item-text"
                :class="(node.data.group_deleted == 1) && muteclass">
                <span
                  v-if="editingnode == null || editingnode.data.folder_id != node.data.folder_id || editingnode.data.group_id != node.data.group_id">
                  {{ node.title }}
                </span>
                <b-form-input
                  v-if="editingnode != null && editingnode.data.folder_id == node.data.folder_id && editingnode.data.group_id == node.data.group_id"
                  :ref="'f' + node.data.folder_id" v-model="editingnodename" class="item-input pb-0 pt-0 mt-0 mb-0"
                  placeholder="Type new name" @keydown.esc="resetEditNode" @keydown.enter.prevent="saveEditNode" />
              </span>
              <!-- Type 1 = Group -->
              <span v-if="node.data.gdqtype == 1" class="item-text group-clickable"
                :class="(node.data.group_deleted == 1) && muteclass"
                @click.prevent="group_setcurrent(node.data.group_id)">
                <span
                  v-if="editingnode == null || editingnode.data.folder_id != node.data.folder_id || editingnode.data.group_id != node.data.group_id">
                  {{ node.title }}
                </span>
                <b-form-input
                  v-if="editingnode != null && editingnode.data.folder_id == node.data.folder_id && editingnode.data.group_id == node.data.group_id"
                  :ref="'g' + node.data.group_id" v-model="editingnodename" class="item-input pb-0 pt-0 mt-0 mb-0"
                  placeholder="Type new name" @keydown.esc="resetEditNode" @keydown.enter.prevent="saveEditNode" />
              </span>
              <!-- Type 3 = Trash -->
              <span v-if="node.data.gdqtype == 3" class="item-text">
                {{ node.title }}
              </span>
              <!-- Type 4 = Add new folder -->
              <!-- Type 5 - No folder -->
            </template>
            <template slot="sidebar" slot-scope="{ node }">
              <div class="ellipsis-button d-flex align-items-center">
                <b-dropdown right
                  v-if="(node.data.gdqtype == 1) && (editingnode == null || editingnode.data.folder_id != node.data.folder_id || editingnode.data.group_id != node.data.group_id)">
                  <template #button-content>
                    <i class="fa-solid fa-ellipsis"></i>
                  </template>
                  <b-dropdown-item @click.prevent="group_setcurrent(node.data.group_id)">Edit</b-dropdown-item>
                  <b-dropdown-item
                    @click.prevent="removeNode(node.data.group_id, node.data.folder_id)">Delete</b-dropdown-item>
                </b-dropdown>
              </div>
            </template>
          </sl-vue-tree>
        </b-form>
      </div>
    </div>
    <div v-if="!loading" class="total-show">
      <span>Showing {{ retrieved }} of {{ total }} folders</span><a class="ml-3" href="/foldersgroups">Show all</a>
    </div>
    <b-modal
      id="delete-confirm-modal"
      v-model="showDeleteModal"
      title="Confirm Delete"
      @ok="confirmDelete"
      ok-title="Delete"
      ok-variant="danger"
      cancel-title="Cancel"
    >
      Are you sure you want to delete this group?
    </b-modal>
  </div>
</template>
<script>
import PopupBubble from '../PopupBubble'

export default {
  name: 'Folders',
  components: {
    // PopupBubble
  },
  data: function () {
    return {
      allowmultiselect: false,
      addingfolder: false,
      newfoldername: '',
      muteclass: 'text-muted',
      editingnode: null,
      editingnodename: '',
      addingnodeto: null,
      addingnodename: '',
      screen_id: 1,
      total: 0,
      retrieved: 0,
      screentexts: [],
      nodes: [],
      loading: true,
      visible: this.$store.state.mypage_folders_open,
      showDeleteModal: false,
      pendingDeleteGroupId: null,
      pendingDeleteFolderId: null
    }
  },
  computed: {
  },
  created () {
    this.groups_get()
    this.screentexts_get()
    this.set_nodes()
  },
  methods: {
    set_nodes () {
      var items = this.$store.state.foldertree.data
      this.total = this.$store.state.foldertree.total
      var modifiedItems = this.restructureItems(items)
      this.nodes = modifiedItems
    },
    restructureItems (items) {
      let newTopLevelObject = {
        title: 'No folder',
        data: {
          'gdqtype': '0'
        },
        children: [],
        isDraggable: false,
        isExpanded: false,
        isLeaf: false,
        isSelectable: false
      }

      let modifiedItems = items.filter(item => {
        if ((!item.children || item.children.length === 0) && item.isLeaf) {
          newTopLevelObject.children.push(item)
          return false
        }
        return true
      })

      modifiedItems.unshift(newTopLevelObject)

      if (modifiedItems.length === 1) {
        newTopLevelObject.isExpanded = true
        this.retrieved = modifiedItems.length
        this.total = modifiedItems.length
      } else {
        this.retrieved = modifiedItems.length - 1
      }

      return modifiedItems
    },
    setvisible: function () {
      this.visible = !this.visible
      this.$store.dispatch('setfoldersopen', this.visible)
    },
    nullfunction: function () {
      return true
    },
    nullfalse: function () {
      return false
    },
    screentexts_get: function () {
      var screentexts = []
      var filter = {
        screen_id: {
          operator: '=',
          value: this.screen_id
        }
      }
      this.$store.dispatch('systemscreenelements_fetch', { filter: filter })
        .then((resp) => {
          var dbtexts = resp.data.result
          for (var i = 0; i < dbtexts.length; i++) {
            var screentext = {
              id: dbtexts[i].id,
              element_text: dbtexts[i].element_text,
              element_bubbletext: dbtexts[i].element_bubbletext
            }
            screentexts[dbtexts[i].id] = screentext
          }
          this.screentexts = screentexts
        })
    },
    resetall () {
      this.addingnodeto = null
      this.editingnode = null
    },
    addNode (node) {
      var folderTree = this.$refs.folderTree
      var selected = document.getElementsByClassName('sl-vue-tree-selected')
      this.addingnodeto = node
      this.$nextTick(() =>
        this.$refs.addingnodeinput.focus())
    },
    resetAddNode () {
      this.addingnodeto = null
    },
    saveAddNode () {
      var folderTree = this.$refs.folderTree
      var parent = this.addingnodeto
      var newfolder = {
        folder_name: this.addingnodename,
        parent_id: parent.data.folder_id
      }
      this.addingnodename = ''
      this.$store.dispatch('folder_create', { folder: newfolder })
        .then(() => {
          this.$store.dispatch('foldertree_fetch', { type: 'new' })
            .then(() => {
              var thisnode = this.addingnodeto
              this.resetAddNode()
              folderTree.select(thisnode.path)
              this.$nextTick(() => folderTree.updateNode(thisnode.path, { isExpanded: true }))
            })
        })
    },
    editNode () {
      event.preventDefault()
      this.addingnode = null
      this.editingnode = null
      var folderTree = this.$refs.folderTree
      folderTree.traverse((node, nodeModel, path) => {
        if (node.isSelected == true) {
          this.editingnode = node
          this.editingnodename = node.title
          if (node.data.gdqtype == 0) {
            this.$nextTick(() => this.$refs['f' + node.data.folder_id].focus())
          }
          if (node.data.gdqtype == 1) {
            this.$nextTick(() => this.$refs['g' + node.data.group_id].focus())
          }
        }
      })
    },
    saveEditNode () {
      var folderTree = this.$refs.folderTree
      var node = this.editingnode
      if (node.data.gdqtype == 0) {
        var folder = {
          id: node.data.folder_id,
          folder_name: this.editingnodename
        }
        this.$store.dispatch('folder_save', { folder: folder })
          .then(() => {
            this.editingnode = null
            this.editingnodename = ''
            this.$store.dispatch('foldertree_fetch', { type: 'new' })
              .then(() => {
                folderTree.select(node.path)
                folderTree.updateNode(node.path, { isExpanded: true })
                return false
              })
          })
      }
      if (node.data.gdqtype == 1) {
        var group = {
          id: node.data.group_id,
          group_name: this.editingnodename
        }
        this.$store.dispatch('group_save', { group: group })
          .then((resp) => {
            this.$emit('reload-dashboard')
          })
      }
    },
    resetEditNode () {
      this.editingnode = null
      this.editingnodename = ''
    },
    removeNode (group_id, folder_id) {
      var will_delete = 0
      var group = {
        id: group_id,
        group_folder_id: -1,
        group_deleted: 1
      }
      var folder = {
        id: folder_id,
        parent_id: -1,
        folder_deleted: 1
      }
      var body = {
        group: group,
        folder: folder,
        type: 1
      }
      if (confirm('Are you sure you want to delete this group?')) {
        will_delete = 1
      } else {
        will_delete = 0
      }

      if (will_delete == 1) {
        this.$store.dispatch('treeitem_save', { id: group_id, body: body })
          .then(() => {
            this.$store.dispatch('foldertree_fetch', { type: 'new' })
              .then(() => {
                // this.removeNodeFromTree(this.nodes, group_id);
                this.$store.dispatch('mygdqpage_setreload', { reload: 1 })
                  .then(() => {
                    this.$nextTick(() => {
                      this.$refs.folderTree.updateNode(this.nodes[0].path, { isExpanded: true })
                    })
                  })
                this.editingnode = null
                this.editingnodename = ''
                this.addingnodeto = null

                return false
              })
          })
      }
    },
    removeNode (group_id, folder_id) {
      this.pendingDeleteGroupId = group_id
      this.pendingDeleteFolderId = folder_id
      this.showDeleteModal = true
    },
    confirmDelete () {
      const group_id = this.pendingDeleteGroupId
      const folder_id = this.pendingDeleteFolderId
      var group = {
        id: group_id,
        group_folder_id: -1,
        group_deleted: 1
      }
      var folder = {
        id: folder_id,
        parent_id: -1,
        folder_deleted: 1
      }
      var body = {
        group: group,
        folder: folder,
        type: 1
      }
      this.$store.dispatch('treeitem_save', { id: group_id, body: body })
        .then(() => {
          this.$store.dispatch('foldertree_fetch', { type: 'new' })
            .then(() => {
              this.removeNodeFromTree(this.nodes, group_id)
              this.$store.dispatch('mygdqpage_setreload', { reload: 1 })
                .then(() => {
                  this.$nextTick(() => {
                    this.$refs.folderTree.updateNode(this.nodes[0].path, { isExpanded: true })
                  })
                })
              this.editingnode = null
              this.editingnodename = ''
              this.addingnodeto = null
              // Emit reload event after delete
              this.$emit('reload-dashboard')
            })
        })
      this.showDeleteModal = false
      this.pendingDeleteGroupId = null
      this.pendingDeleteFolderId = null
    },
    removeNodeFromTree (nodes, group_id) {
      for (let i = nodes.length - 1; i >= 0; i--) {
        const node = nodes[i]
        if (node.data && node.data.group_id === group_id) {
          nodes.splice(i, 1)
        } else if (node.children && node.children.length > 0) {
          this.removeNodeFromTree(node.children, group_id)
        }
      }
    },
    toggleExpand (selectednode, event) {
      if (this.addingnodeto == null && this.editingnode == null) {
        var folderTree = this.$refs.folderTree
        // ----------------------
        // Folder, toggle expand
        // ----------------------
        if (selectednode.data.gdqtype == 0 || selectednode.data.gdqtype == 3) {
          folderTree.traverse((node, nodeModel, path) => {
            if (node.data.folder_id == selectednode.data.folder_id) {
              if (node.data.folder_id != 0) {
                var expand = !(node.isExpanded)
                folderTree.updateNode(node.path, { isExpanded: expand })
              }
            }
          })
        }
      }
      this.addingnodeto = null
    },
    checkDrop (dragginNodes, position, cancel) {
      if (position.node.data.gdqtype == 1 || position.node.data.gdqtype == 4) {
        cancel(true)
      }
    },
    nodeDropped (draggingNodes, position, event) {
      var gdqtype = draggingNodes[0].data.gdqtype
      var group_id = draggingNodes[0].data.group_id
      var folder_id = draggingNodes[0].data.folder_id
      var to_folder_id = position.node.data.folder_id
      var group_deleted = position.node.data.gdqtype == 3 ? 1 : 0
      var folder_deleted = position.node.data.gdqtype == 3 ? 1 : 0
      var group = {
        id: group_id,
        group_folder_id: to_folder_id,
        group_deleted: group_deleted
      }
      var folder = {
        id: folder_id,
        parent_id: to_folder_id,
        folder_deleted: folder_deleted
      }
      var body = {
        group: group,
        folder: folder,
        type: gdqtype
      }
      var id = 0
      if (gdqtype == 0) { id = folder_id }
      if (gdqtype == 1) { id = group_id }

      this.$store.dispatch('treeitem_save', { id: id, body: body })
        .then(() => {
          this.groups_get()
        })
    },
    groups_get: function () {
      this.$store.dispatch('foldertree_fetch', { type: 'new', search: this.search, drag: 1 })
        .then(() => {
          this.items = this.$store.state.foldertree.data
        }).then(() => {
          this.nodes = this.restructureItems(this.items)
          this.loading = false
        })
    },
    group_setcurrent: function (group_id) {
      this.$store.dispatch('group_setcurrent', group_id)
      this.$router.push('/group')
    },
    opengroup: function (node, event) {
    }
  }
}
</script>
<style>
.item-icon {
  display: inline-block;
  /* width: 30px; */
  margin-right: 4px;
  font-size: 1.1em !important;
}

.item-text {
  font-size: 1em !important;
}

.item-input {
  font-size: 1em !important;
}
</style>
